// Port of api/fuel/app/classes/insights/players/directory.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'directory',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	run: function() {
		var list = (this._data.players || []).map(function(player) {
			return {
				id: parseInt(player.id, 10) || 0,
				slug: player.slug,
				name: player.primaryName,
				username: player.username,
				plays: parseInt(player.totalPlays, 10) || 0,
				games: parseInt(player.totalGames, 10) || 0,
				date: parseInt(player.dateLast, 10) || 0,
				ratio: parseFloat(player.winRatio) || 0
			}
		})

		return {
			directory: Util.sort_by_field_php(list, 'name', true)
		}
	}
})
